module.exports = __webpack_public_path__ + "img/label.3a9f83d1.png";